import { IBudgetantrag } from "./IBudgetantrag";
import { IProjektInfo } from "./IProjektInfo";

export class ProjektInfo implements IProjektInfo {
    
    static default = {
        name: '',
        controllingbereich: '',
        plangebiet: '',
        quartier: '',
        klassifizierung: '',
        projektmanager: '',
        projektsteuerer: '',
        kostengruppe: '',
        kostenstelle: '',
        bearbeiter: '',
        status: '',
        budgetaktuell: 0,
        istkosten: 0,
        auftragswerte: 0,
		budgetantraege: []
    }

    constructor(
        public name: string,
        public controllingbereich: string,
        public plangebiet: string,
        public quartier: string,
        public klassifizierung: string,
        public projektmanager: string,
        public projektsteuerer: string,
        public kostengruppe: string,
        public kostenstelle: string,
        public bearbeiter: string,
        public status: string,
        public budgetaktuell: number,
        public istkosten: number,
        public auftragswerte: number,
		public budgetantraege: IBudgetantrag[]
    ) {}
}
